<template>

  <v-layout class="back" style="height: 800px" column fill-height justify-start ma-0>

    <v-toolbar dense color="secondary" dark class="elevation-0 node-create-toolbar">

        <v-toolbar-title class="no-select">{{$t('PDF reports')}}</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-toolbar-items class="no-select">
          <v-btn :data-testid="$options.name + 'v-btn' + 'close'" icon flat slot="activator" @click="close">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>

    </v-toolbar>

    <v-layout fill-height row  ma-0>

        <v-flex xs5 style="position: relative" class="back" px-2>

          <scroll-area>

            <template slot="body">

              <v-flex v-show = "!editMode" shrink pa-1>
                <v-select :data-testid="$options.name + 'v-select' + 'currentTemplate'"
                  v-model="currentTemplate"
                  light
                  :items="getTemplates"
                  :label="$t('templates')"
                  :menu-props="{ maxHeight: '400' }"
                  solo
                  hide-details
                  dense
                  flat
                  clearable
                >
                  <template v-slot:item="{ item, index }">
                      <span>{{ $t(String(item.name)) }}</span>
                  </template>
                  <template v-slot:selection="{ item, index }">
                      <span>{{ $t(String(item.name)) }}</span>
                  </template>
                </v-select>

                <v-btn :data-testid="$options.name + 'v-btn' + 'createFields'" v-if="!currentTemplate" color="primary" small @click="createFields">{{ $t('create') }}</v-btn>
              </v-flex>

              <v-layout v-if="currentTemplate" column fill-height  justify-start ma-0>

                <v-form ref="report-form" style="height: 100%">

                  <v-flex shrink pt-1 v-for="(field, index) in getFields" :key="index" v-if="field.name.charAt(0) != '$'">

                      <v-text-field
                        v-if="field.type == 'text'"
                        v-model="model.obj[field.name]"
                        light
                        auto-grow
                        outline
                        flat
                        :readonly = "!editMode"
                        class="white"
                        color="primary"
                        background-color="white"
                        hide-details
                        :label="$t(field.name)"
                        rows="1"
                      ></v-text-field>

                      <v-flex v-if="field.type == 'json[]'" px-1 :style="'position: relative;'">
                        <div v-if="!editMode" :style="`position: absolute !important; height: 100%; width: 100%; z-index: 2;`"></div>
                        <span :class="editMode ? 'subheading primary--text' : 'subheading'">{{$t(field.name)}}</span>
                        <vue-editor
                          :id="field.name"
                          :disabled = "!editMode"
                          v-model="model.obj[field.name]"
                          :customModules="customModulesForEditor"
                          :editor-toolbar="customToolbar"
                          :editorOptions="editorSettings"
                          @change="(payload) => testClickFocus(payload)"
                          @ready="(payload) => prepareEditor(payload, field.name)"
                        >
                        </vue-editor>

                      </v-flex>

                      <v-text-field
                        v-if="field.type == 'timestamp' && !editMode"
                        :value="showDate(model.obj[field.name])"
                        light
                        auto-grow
                        outline
                        flat
                        readonly
                        :label="$t(field.name)"
                        class="white"
                        background-color="white"
                        hide-details
                        rows="1"
                      ></v-text-field>

                      <v-select :data-testid="$options.name + 'v-select' + field.name"
                        v-if="field.type == 'select'"
                        v-model="model.obj[field.name]"
                        light
                        auto-grow
                        :items="getItems[field.cls]"
                        :item-text="field.type == 'select' ? 'name' : 'value'"
                        :item-value="field.type == 'select' ? '$id' : 'id'"
                        :label="$t(field.name)"
                        class="white"
                        color="primary"
                        background-color="white"
                        :menu-props="{ maxHeight: '400' }"
                        outline
                        hide-details
                        dense--
                        flat
                        multiple
                        clearable
                      >
                      <template v-slot:item="{ item, index }">
                          <span>{{ item.name }}</span>
                      </template>
                      <template v-slot:selection="{ item, index }">
                          <span v-if="model.obj[field.name] && model.obj[field.name].length > 1">{{ item.name }} /</span>
                          <span v-else>{{ item.name }}</span>
                      </template>
                      </v-select>

                      <v-flex shrink pl-2>
                        <v-checkbox :data-testid="$options.name + 'v-checkbox' + field.name"
                          :disabled = "!editMode"
                          v-if="field.type == 'boolean'" small light color="secondary"
                          v-model="model.obj[field.name]"
                          hide-details
                        >
                          <template v-slot:label>
                            <span class="black--text">{{$t(field.name)}}</span>
                          </template>
                        </v-checkbox>
                      </v-flex>

                  </v-flex>

                </v-form>

              </v-layout>

            </template>

            <template slot="footer">

              <v-layout v-if="currentTemplate" row justify-end>

                <v-btn :data-testid="$options.name + 'v-btn' + 'generatePDF'" v-if="currentTemplate" color="secondary" small @click="generatePDF">{{ $t('update preview') }}</v-btn>
                <v-btn :data-testid="$options.name + 'v-btn' + 'createFields'" v-if="currentTemplate.$id && !editMode" color="primary" small @click="createFields">{{ $t('create') }}</v-btn>
                <v-btn :data-testid="$options.name + 'v-btn' + 'editTemplate'" v-if="currentTemplate.$id && !editMode" color="grey" @click="editTemplate" active-class small dark>{{ $t('edit') }}</v-btn>
                <v-btn :data-testid="$options.name + 'v-btn' + 'deleteTemplate'" v-if="currentTemplate.$id && editMode" color="black"  dark small @click="deleteTemplate">{{ $t('delete') }}</v-btn>
                <v-btn :data-testid="$options.name + 'v-btn' + 'saveTemplate'" v-if="currentTemplate.$id && editMode" color="primary" small @click="saveTemplate">{{ $t('save') }}</v-btn>
                <v-btn :data-testid="$options.name + 'v-btn' + 'thiseditMode--false'" v-if="currentTemplate.$id && editMode" color="grey" @click="() => {this.editMode = false}" active-class small dark>{{ $t('cancel') }}</v-btn>
                <v-btn :data-testid="$options.name + 'v-btn' + 'saveTemplate'" v-if="!currentTemplate.$id" color="primary" small @click="saveTemplate">{{ $t('save') }}</v-btn>
                <v-btn :data-testid="$options.name + 'v-btn' + 'thiscurrentTemplate--null-thiseditMode--false'" v-if="!currentTemplate.$id" color="grey" @click="() => {this.currentTemplate = null; this.editMode = false}" active-class small dark>{{ $t('cancel') }}</v-btn>

                </v-layout>

            </template>

          </scroll-area>

        </v-flex>

        <v-flex grow px-0>

          <v-layout ref="pdf_preview_wrapper" fill-height v-show="currentTemplate">
            <iframe ref="pdf_preview" type="application/pdf" src="" width="100%" height="100%"></iframe>
          </v-layout>

        </v-flex>

    </v-layout>

  </v-layout>

</template>

<script lang="ts">
import Vue from 'vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'
import datePicker from '@/nms/components/controls/input-menu-datepicker.vue'
import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import myFont from '@/nms/assets/RobotoCondensed-Regular-normal.js'
import { VueEditor } from 'vue2-editor'
import ImageResize from 'quill-image-resize-vue'
import { ImageDrop } from 'quill-image-drop-module'

// Типы
interface TableColumn {
  title: string
  value: string
  width: string
  type?: string
  [key: string]: any
}

interface TableData {
  columns: TableColumn[]
  rows: Record<string, any>[]
}

interface ModelField {
  type?: string
  name?: string
  value?: any
  [key: string]: any
}

interface ModelData {
  fields: Record<string, ModelField>
  obj: Record<string, any>
  items?: Record<string, any>
}

interface TemplateItem {
  $id?: string
  name?: string
  [key: string]: any
}

interface BookItem {
  $id?: string
  name?: string
  childrenMeta?: any
  children?: TemplateItem[]
  [key: string]: any
}

interface CmdbQueryResponse {
  children?: TemplateItem[]
  refs?: Array<{ ref?: string; name?: string; $id?: string }>
  [key: string]: any
}

interface FileData {
  name?: string
  content?: string
  [key: string]: any
}

interface EditorModule {
  alias: string
  module: any
}

export default Vue.extend({
  name: 'FORM_PDF_REPORTS',

  components: {
    scrollArea,
    datePicker,
    VueEditor
  },

  props: {
    table: {
      type: Object as () => TableData,
      default: () => ({ columns: [], rows: [] })
    },
  },

  data(): {
    meta: any | null
    templates: TemplateItem[]
    newTemplate: TemplateItem | null
    currentTemplate: TemplateItem | null
    editMode: boolean
    model: ModelData
    top_main: string
    top_content: string
    bottom_content: string
    customModulesForEditor: EditorModule[]
    customToolbar: any[][]
    editorSettings: Record<string, any>
    previewURL?: string
    showRefs?: boolean
  } {
    return {
      meta: null,
      templates: [],
      newTemplate: null,
      currentTemplate: null,
      editMode: false,
      model: {
        fields: {},
        obj: {},
        items: {},
      },
      top_main: '',
      top_content: '',
      bottom_content: '',
      customModulesForEditor: [
        { alias: 'imageDrop', module: ImageDrop },
        { alias: 'imageResize', module: ImageResize }
      ],
      customToolbar: [
        ['bold', 'italic', 'underline', 'strike'],
        ['blockquote', 'code-block'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ script: 'sub' }],
        [{ indent: '-1' }, { indent: '+1' }],
        [{ direction: 'rtl' }],
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        [{ color: [] }],
        [{ align: [] }],
        ['clean']
      ],
      editorSettings: {
        modules: {
          imageDrop: true,
          imageResize: {}
        }
      }
    }
  },

  computed: {
    getTemplates(): TemplateItem[] {
      return this.templates
    },

    getFields(): Record<string, ModelField> {
      return this.model.fields
    },

    getItems(): Record<string, any> {
      return this.model.items || {}
    },

    getBook(): BookItem[] {
      return this.$store.state.books.books.filter((book: BookItem) => book.name === 'pdf_reports')
    },
  },

  watch: {
    currentTemplate: {
      handler(newVal: TemplateItem | null): void {
        console.log('FORM_PDF_REPORTS', 'WATCH', 'currentTemplate', newVal)
        if (!newVal) return
        this.setup()
      },
      deep: true
    },
  },

  created(): void {
    this.setup()
  },

  methods: {
    testClickFocus(e: Event): void {
      console.log('FORM_PDF_REPORTS', 'testClickFocus', 'e', e)
    },

    setup(): void {
      if (!this.currentTemplate) return
      this.loadMeta()
    },

    prepareEditor(e?: any, id?: string): void {
      const element = document.getElementById(id || '')
      if (element) {
        const editor = element.querySelector('.ql-editor') as HTMLElement
        if (editor) {
          editor.style.minHeight = 'auto'
          editor.style.fontSize = '12px'
          editor.style.lineHeight = '1'
        }
      }
    },

    async loadFiles(obj: { $id?: string }): Promise<void> {
      try {
        this.setLoader('loadFiles', true)
        const files = await this.$loadFiles(obj.$id) as FileData[]
        if (files?.length) {
          for (const file of files) {
            const fileName = file.name?.substring(0, file.name.lastIndexOf('.'))
            if (fileName && file.content) {
              this.$set(this.model.obj, fileName, JSON.parse(file.content))
            }
          }
        }
        this.setLoader('loadFiles', false)
      } catch (err) {
        console.error('CATCH', this.$options.name, 'loadFiles', err)
        this.setLoader('loadFiles', false)
      }
    },

    async loadMeta(): Promise<void> {
      const book = this.getBook
      if (book.length) {
        this.meta = book[0].childrenMeta
        this.templates = []
        
        const query = {
          id: [book[0].$id],
          data: { children: { data: { refs: true } } }
        }
        const obj = await this.$bridge.cmdbQuery(query) as CmdbQueryResponse[]
        
        if (this.$store.state.auth.user?.level) {
          if (obj?.length) {
            obj[0].children?.forEach(child => {
              if (child.refs?.some(ref => ref.name === this.$store.state.auth.user?.login)) {
                this.templates.push(child)
              }
            })
          }
        } else {
          this.templates = obj?.[0]?.children || []
        }
        
        console.log('FORM_PDF_REPORTS', 'loadMeta', 'templates', this.templates)
        
        if (this.meta) {
          this.model = await this.$prepareMeta(this.meta, this.$options.name)
          if (this.currentTemplate) {
            this.prepareData()
          }
          console.log('FORM_PDF_REPORTS', 'loadMeta', 'meta', this.meta)
        }
      }
    },

    createFields(): void {
      this.currentTemplate = this.$merge({}, this.newTemplate)
      this.editMode = true
    },

    async prepareData(): Promise<void> {
      try {
        const fields = Object.keys(this.model.fields)
        fields.forEach(name => {
          if (this.currentTemplate && this.currentTemplate[name] && this.model.fields[name]?.type !== 'json[]') {
            this.$set(this.model.fields[name], 'value', this.currentTemplate[name])
            this.$set(this.model.obj, name, this.currentTemplate[name])
          }
          if (this.currentTemplate && this.model.fields[name]?.type === 'json[]') {
            this.$set(this.model.fields[name], 'value', '')
            this.$set(this.model.obj, name, '')
          }
        })
        
        if (this.currentTemplate?.$id && this.meta?.refs) {
          const query = {
            id: [this.currentTemplate.$id],
            notNull: true,
            data: { refs: true }
          }
          const obj = await this.$bridge.cmdbQuery(query) as CmdbQueryResponse[]
          
          if (obj?.[0]?.refs) {
            obj[0].refs.forEach(ref => {
              if (this.model.fields[ref.ref || '']) {
                if (this.model.obj[ref.ref || '']) {
                  this.model.obj[ref.ref || ''].push(ref.$id)
                } else {
                  this.$set(this.model.obj, ref.ref || '', [])
                  this.model.obj[ref.ref || ''].push(ref.$id)
                }
                this.showRefs = true
              }
            })
          }
        }
        
        if (this.currentTemplate?.$id) {
          await this.loadFiles(this.currentTemplate)
          this.generatePDF()
        } else {
          this.generatePDF()
        }
      } catch (error) {
        console.error('CATCH', 'FORM_PDF_REPORTS', 'prepareData', 'SMTH WRONG', error)
      }
    },

    async getEnum(cls: string): Promise<any[] | undefined> {
      try {
        const items = await this.$bridge.getEnum(cls)
        return items
      } catch (error) {
        console.error('CATCH', 'FORM_PDF_REPORTS', 'getEnum', 'SMTH WRONG', error)
        return undefined
      }
    },

    async loadRefs(cls: string): Promise<any[]> {
      try {
        if (cls === 'measure') return []
        const children = await this.$bridge.getObjectsByClass(cls)
        return children || []
      } catch (error) {
        console.error('CATCH', 'FORM_PDF_REPORTS', 'loadRefs', 'SMTH WRONG', error)
        return []
      }
    },

    editTemplate(): void {
      this.editMode = true
    },

    async saveTemplate(): Promise<void> {
      console.log('FORM_PDF_REPORTS', 'saveTemplate', 'model', this.model)
      this.editMode = false
      const id = this.currentTemplate?.$id
      await this.updateBook(id)
    },

    async generatePDF(): Promise<void> {
      const table$ = this.$merge({}, this.table) as TableData
      console.log('table$', table$)
      
      const columns = table$.columns.map(column => ({
        ...column,
        title: this.$getTranslate(column.title)
      }))
      
      const doc = new jsPDF({
        orientation: 'landscape',
        unit: 'px',
        format: 'a4'
      })

      doc.addFileToVFS('RobotoCondensed-Regular.ttf', myFont)
      doc.addFont('RobotoCondensed-Regular.ttf', 'MyFont', 'normal')
      doc.setFont('MyFont')

      const preview = this.$refs['pdf_preview'] as HTMLImageElement
      const wrapper = this.$refs['pdf_preview_wrapper'] as HTMLElement

      // Формирование HTML для главного заголовка
      const topMainById = document.getElementById('top_main')
      let topMainElement: HTMLElement | null = null
      let topMainOriginal: HTMLElement | null = null
      
      if (this.model.obj.top_main?.length) {
        const editor = topMainById?.querySelector('.ql-editor') as HTMLElement
        if (editor) {
          topMainOriginal = editor
          topMainElement = editor.cloneNode(true) as HTMLElement
          topMainElement.style.width = `${doc.getPageWidth() - 16}px`
          topMainElement.style.minHeight = 'auto'
          topMainElement.style.lineHeight = '1'
          topMainElement.style.padding = '8px 8px 8px 8px'
          topMainElement.style.fontFamily = 'MyFont'
        }
      }

      // Формирование HTML для заголовка остальных страниц
      const topById = document.getElementById('top')
      let topElement: HTMLElement | null = null
      let topOriginal: HTMLElement | null = null
      
      if (this.model.obj.top?.length) {
        const editor = topById?.querySelector('.ql-editor') as HTMLElement
        if (editor) {
          topOriginal = editor
          topElement = editor.cloneNode(true) as HTMLElement
          topElement.style.width = `${doc.getPageWidth() - 16}px`
          topElement.style.minHeight = 'auto'
          topElement.style.lineHeight = '1'
          topElement.style.padding = '8px 8px 8px 8px'
          topElement.style.fontFamily = 'MyFont'
        }
      }

      // Using autoTable plugin
      let startY = 8
      if (topMainOriginal) {
        startY = topMainOriginal.clientHeight - 8
      } else if (topOriginal) {
        startY = topOriginal.clientHeight
      }

      const docWidth = doc.getPageWidth() - 16
      let sumColWidth = 0
      table$.columns.forEach(column => {
        const n = parseFloat(column.width.slice(0, -1))
        sumColWidth += n
      })
      const normalizeIndex = 100 / sumColWidth

      const countWidth = (percent: string | number): number => {
        let percentNum = typeof percent === 'string' ? parseFloat(percent.slice(0, -1)) : percent
        return docWidth * (percentNum * 0.01)
      }

      const columnStyles: Record<number, { minCellWidth: number }> = {}
      table$.columns.forEach((column, index) => {
        const width = countWidth(column.width) * normalizeIndex
        columnStyles[index] = { minCellWidth: width }
      })

      console.log('COLUMN_STYLES', columnStyles)

      await doc.autoTable({
        styles: { font: 'MyFont' as any },
        columnStyles,
        columns: columns as any,
        body: this.getFormattedDate(table$.rows),
        bodyStyles: { fillColor: '#FFFFFF' },
        alternateRowStyles: { fillColor: '#FFFFFF' },
        headStyles: { fillColor: '#E1E1E1', textColor: '#4B4B4B' },
        startY: startY,
        margin: { left: 8, top: 8, right: 8, bottom: 8 },
        didDrawPage: (data) => {
          if (topElement && topOriginal) {
            data.settings.margin.top = topMainOriginal ? topOriginal.clientHeight - 8 : topOriginal.clientHeight
          }
        },
      })

      const pageCount = doc.internal.getNumberOfPages()

      // Формирование HTML для подвала
      const bottomById = document.getElementById('bottom')
      let bottomElement: HTMLElement | null = null
      
      if (this.model.obj.bottom?.length) {
        const editor = bottomById?.querySelector('.ql-editor') as HTMLElement
        if (editor) {
          let margTop = '8px'
          if (topMainOriginal) {
            margTop = `${doc.lastAutoTable.finalY - topMainOriginal.clientHeight + 8}px`
          } else if (topOriginal) {
            margTop = `${doc.lastAutoTable.finalY - topOriginal.clientHeight + 8}px`
          }
          bottomElement = editor.cloneNode(true) as HTMLElement
          bottomElement.style.width = `${doc.getPageWidth() - 16}px`
          bottomElement.style.minHeight = 'auto'
          bottomElement.style.lineHeight = '1'
          bottomElement.style.marginTop = margTop
          bottomElement.style.padding = '8px 8px 8px 8px'
          bottomElement.style.fontFamily = 'MyFont'
        }
      }

      // Формирование ОБЩЕГО HTML
      let mainElement: HTMLElement | null = null
      
      if (topMainElement) {
        mainElement = document.createElement('div')
        mainElement.insertAdjacentElement('afterbegin', topMainElement)
        if (topElement) {
          for (let i = 1; i < pageCount; i++) {
            const el = topElement.cloneNode(true) as HTMLElement
            el.style.marginTop = i === 1 
              ? `${doc.internal.pageSize.height - topMainOriginal!.clientHeight + 8}px`
              : `${doc.internal.pageSize.height - topOriginal!.clientHeight + 8}px`
            mainElement.insertAdjacentElement('beforeend', el)
          }
        }
        if (bottomElement) {
          mainElement.insertAdjacentElement('beforeend', bottomElement)
        }
      } else if (topElement) {
        mainElement = document.createElement('div')
        for (let i = 1; i <= pageCount; i++) {
          const el = topElement.cloneNode(true) as HTMLElement
          el.style.marginTop = i === 1 ? '8px' : `${doc.internal.pageSize.height - topOriginal!.clientHeight + 8}px`
          mainElement.insertAdjacentElement('beforeend', el)
        }
        if (bottomElement) {
          mainElement.insertAdjacentElement('beforeend', bottomElement)
        }
      } else if (bottomElement) {
        mainElement = document.createElement('div')
        bottomElement.style.marginTop = `${(pageCount - 1) * doc.internal.pageSize.height + doc.lastAutoTable.finalY}px`
        mainElement.insertAdjacentElement('beforeend', bottomElement)
      }

      // добавляем html в pdf
      if (mainElement) {
        await doc.html(mainElement, { x: 8, y: 0 })
      }

      // добавляем номера страниц
      if (this.model.obj.show_num_pages) {
        for (let i = 1; i <= pageCount; i++) {
          doc.setPage(i)
          doc.setFontSize(10)
          doc.setTextColor(88, 88, 88)
          doc.text(
            doc.internal.pageSize.width - 24,
            doc.internal.pageSize.height - 8,
            String(i)
          )
        }
      }

      this.previewURL = doc.output('dataurlstring', '11111')
      if (preview) {
        preview.src = this.previewURL
      }
    },

    getFormattedDate(rows: Record<string, any>[]): Record<string, any>[] {
      const rows$: Record<string, any>[] = []
      rows.forEach(row => {
        const row$: Record<string, any> = {}
        const keys$ = Object.keys(row)
        keys$.forEach(key$ => {
          const column$ = this.table.columns.find(column => column.value === key$)
          if (column$?.type === 'timestamp' && row[key$]) {
            row$[key$] = (this as any).$moment(row[key$]).format('DD MM YYYY HH:mm')
          } else {
            row$[key$] = this.$getTranslate(row[key$])
          }
        })
        rows$.push(row$)
      })
      return rows$
    },

    showDate(date: Date | string): string {
      if (date) {
        if (typeof date === 'string') {
          return date.substring(0, 10).split('-').reverse().join('.')
        }
        const date$ = new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString()
        return date$.substring(0, 10).split('-').reverse().join('.')
      }
      return ''
    },

    onDateChange(payload: any, fieldName: string): void {
      this.$set(this.model.obj, fieldName, payload)
    },

    async updateBook(id?: string): Promise<void> {
      const formRef = this.$refs['report-form'] as any
      const valid = formRef?.validate() ?? false
      console.log('valid', valid)
      if (!valid) return
      
      const data$: Record<string, any> = {}
      const files$: string[] = []
      const fields = Object.keys(this.model.obj)
      
      fields.forEach(field => {
        const fieldType = this.model.fields[field]?.type
        if (fieldType !== 'json[]') {
          data$[field] = this.model.obj[field]
        }
        if (fieldType === 'json[]' && this.model.obj[field]?.length) {
          files$.push(field)
        }
        if (fieldType === 'timestamp') {
          if (this.model.fields[field]?.name === 'date_create' && !this.model.obj[field]) {
            data$[field] = new Date()
          }
          if (this.model.fields[field]?.name === 'date_update') {
            data$[field] = new Date()
          }
        }
      })

      console.log('FILES$$$', files$)

      try {
        if (id) {
          const $obj = await this.$bridge.getObjectById(id)
          const u = await $obj.update(data$)
          if (u) {
            console.log('FORM_PDF_REPORTS', 'updateBook', 'response', u)
            for (const key of files$) {
              await u.attacheDocument(`${key}.json`, JSON.stringify(this.model.obj[key]))
            }
            this.editMode = false
            await this.loadMeta()
            this.currentTemplate = null
            this.setup()
          }
        } else {
          const book = this.getBook
          if (book.length) {
            const $obj = await this.$bridge.getObjectById(book[0].$id)
            const c = await $obj.createChild(this.meta?.cls, data$)
            if (c) {
              for (const key of files$) {
                await c.attacheDocument(`${key}.json`, JSON.stringify(this.model.obj[key]))
              }
              this.editMode = false
              await this.loadMeta()
              this.currentTemplate = null
              this.setup()
            }
          }
        }
      } catch (err) {
        console.error('CATCH', 'FORM_PDF_REPORTS', 'updateBook', err)
        this.$errorHandler(err)
      }
    },

    async deleteTemplate(): Promise<void> {
      const obj = await this.$bridge.getObjectById(this.currentTemplate?.$id)
      if (obj) {
        const d = await obj.delete()
        if (d) {
          this.editMode = false
          this.currentTemplate = null
          await this.loadMeta()
          this.setup()
        }
      }
    },

    close(): void {
      this.$nextTick(() => {
        this.$emit('close')
      })
    },

    setLoader(name: string, status: boolean): void {
      this.$store.dispatch('setLoader', {
        key: name,
        value: status
      })
    },
  },
})
</script>

<style lang="css" scoped>
</style>
